import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon from '../Icon';

import SafetyCleaning from '../../svg/icons/ic_cleaning-prevention_40x40.svg';
import SafetyContactless from '../../svg/icons/ic_contactless-policies_40x40.svg';
import SafetyEquipment from '../../svg/icons/ic_protective-equipment_40x40.svg';
import SafetySocialDistancing from '../../svg/icons/ic_social-distancing_40x40.svg';
import SafetyStaffing from '../../svg/icons/ic_staffing-operations_40x40.svg';

import './SafetyMeasureCategoryIcon.scss';

export const SAFETY_CATEGORIES_BY_TYPE = {
  SOCIAL_DISTANCING: 1,
  CONTACTLESS_POLICIES: 2,
  CLEANING_AND_PREVENTION: 3,
  PROTECTIVE_EQUIPMENT: 4,
  STAFFING_AND_OPERATIONS: 5,
};

export const SAFETY_ICON_BY_CATEGORY = {
  [SAFETY_CATEGORIES_BY_TYPE.SOCIAL_DISTANCING]: SafetySocialDistancing,
  [SAFETY_CATEGORIES_BY_TYPE.CONTACTLESS_POLICIES]: SafetyContactless,
  [SAFETY_CATEGORIES_BY_TYPE.CLEANING_AND_PREVENTION]: SafetyCleaning,
  [SAFETY_CATEGORIES_BY_TYPE.PROTECTIVE_EQUIPMENT]: SafetyEquipment,
  [SAFETY_CATEGORIES_BY_TYPE.STAFFING_AND_OPERATIONS]: SafetyStaffing,
};

const SafetyMeasureCategoryIcon = ({ category, className, big }) => {
  const { id, value } = category;

  return (
    <div
      className={classnames('SafetyMeasureCategoryIcon', className, { big })}
    >
      <Icon
        component={SAFETY_ICON_BY_CATEGORY[id]}
        name={value}
        height="50px"
        width="50px"
      />
      <div className="SafetyMeasureCategoryIcon__category-name">{value}</div>
    </div>
  );
};

SafetyMeasureCategoryIcon.propTypes = {
  category: PropTypes.shape({
    id: PropTypes.number.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
  className: PropTypes.string,
  big: PropTypes.bool,
};

SafetyMeasureCategoryIcon.defaultProps = {
  className: '',
  big: false,
};

SafetyMeasureCategoryIcon.displayName = 'SafetyMeasureCategoryIcon';
export default SafetyMeasureCategoryIcon;
